module.exports = require('../package.json').version;



//////////////////
// WEBPACK FOOTER
// ./~/web3-providers-ws/~/websocket/lib/version.js
// module id = X845
// module chunks = 0